<template>
  <el-dialog :visible.sync="visible" width="900px" title="福袋" @close="handleClose" append-to-body>
    <el-table :data="adminList" >
      <el-table-column prop="name" label="福袋类型" />
      <el-table-column prop="identity" label="福袋内容" />
      <el-table-column prop="phone" label="抽奖时间" />
      <el-table-column prop="phone" label="开奖时间" />
      <el-table-column prop="phone" label="状态" />
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      formVisible: false,
      adminList: [],
      form: {
        admin: ''
      },
      adminOptions: []
    }
  },
  methods: {
    handleShow(row) {
      this.fetchAdmins()
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    fetchAdmins() {
      // 这里请求接口获取管理员列表
      this.adminList = [
        { avatar: 'xxx', name: '张某玲', identity: '张某玲', phone: '12345633654' },
        // ...更多
      ]
    },
  }
}
</script>